module.exports = __webpack_public_path__ + "static/media/mickey3_no_letterbox1.01f007c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_no_letterbox1.png
// module id = 47
// module chunks = 0